$(function(){  
  
  var mql = window.matchMedia("(min-width: 1023px)")

  mediaqueryresponse(mql)

  mql.addListener(mediaqueryresponse)

  function mediaqueryresponse(mql) {
    if (mql.matches) {   
        $('.tab-wrapper .tab-row:not(:first) .tab .tab-links').attr('aria-selected','false');
        $('.tab-row:first .tab-links').addClass('active').attr('aria-selected','true');
        $('.tab-row .tab-content').css('visibility','hidden');
        $('.tab-row:first .tab-content').css('visibility','visible');
        var heights = $(".tab-content-wrap").map(function (){
                          return $(this).height();
                      }).get();
            maxHeight = Math.max.apply(null, heights);
        $('.tab-wrapper').css('height', maxHeight)
                    
        $('.tab-links').on('click',function(){
            var currentTab = $(this).parent('.tab').next('.tab-content')
          if($(this).attr('aria-selected','false')){          
            $(this).attr('aria-selected','true');
            $(this).addClass('active');
            $('.tab-links').not(this).removeClass('active').attr('aria-selected','false');

            currentTab.css('visibility','visible');
            $('.tab-content').not(currentTab).css('visibility','hidden');
          }
        });
    }else{
        $('.tab-wrapper').css('height', 'auto');
        $('.tab-links').attr('aria-expanded','false');

        $('.tab-links').on('click',function(e){
          var $tabBtn = $(event.target);
          var $tabActive = $(event.target).hasClass('active');
          var currentTab = $tabBtn.parent('.tab').next('.tab-content');
          $tabBtn.toggleClass('active');

          if($tabActive){
            $tabBtn.attr('aria-expanded','false');
            currentTab.css('max-height','0px');
          } else if(!$tabActive){
            $tabBtn.attr('aria-expanded','true');
            currentTab.css('max-height','3000px');
          }
        });
    }
  } 
});